module.exports = __webpack_public_path__ + "static/m.power-app-icon-6b531eb12f93a0f587c3e9bae9839570.png";